import { render, staticRenderFns } from "./TrainingServe_phone.vue?vue&type=template&id=5d8acd09&scoped=true&"
import script from "./TrainingServe_phone.vue?vue&type=script&lang=js&"
export * from "./TrainingServe_phone.vue?vue&type=script&lang=js&"
import style0 from "./TrainingServe_phone.vue?vue&type=style&index=0&id=5d8acd09&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8acd09",
  null
  
)

export default component.exports